<template>
<div>
  <md-dialog :md-active.sync="showImportDialog">
    <md-dialog-title>導入紀錄</md-dialog-title>
    <md-dialog-content>
      <md-tabs>
        <md-tab md-label="選擇前次紀錄">
          <md-table v-if="records.length > 0">
            <md-table-row>
              <md-table-head>掛號時間</md-table-head>
            </md-table-row>
            <md-table-row v-for="record in records" :key="record.id" v-if="records.length > 1">
              <md-table-cell>
                <a @click="importRecord(record)">
                  {{dateConvert(record.registered_at)}}
                </a>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>
      </md-tabs>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('closeImportDialog')">關閉</md-button>
    </md-dialog-actions>
  </md-dialog>
</div>
</template>

<script>
import axios from 'axios'
import urls from '@/urls'
import dateConvert from '@/services/dateConvert'

export default {
  props: ['showImportDialog', 'patientID'],
  data () {
    return {
      records: []
    }
  },
  components: {
  },
  methods: {
    dateConvert,
    importRecord (record) {
      this.$emit('importRecord', record.id, true)
      this.$emit('closeImportDialog')
    },
    async getRecords (patientID) {
      let req = await axios.get(urls({route: 'record'}), {params: {patient_id: patientID}})
      this.records = req.data.data
    }
  },
  watch: {
    showImportDialog: function () {
      this.getRecords(this.patientID)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Record/RecordImport.vue